import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsString, ValidateNested, IsBoolean, IsOptional } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class GDSBookingItem {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  agentId!: string;
  @IsString()
  @Expose()
  pcccode!: string;
  @IsOptional()
  @IsString()
  @Expose()
  cashier!: string | null;
  @IsString()
  @Expose()
  recordLocator!: string;
  @IsString()
  @Expose()
  firstNumber!: string;
  @IsString()
  @Expose()
  passengerName!: string;
  @IsString()
  @Expose()
  name!: string;
  @IsNumber()
  @Expose()
  status!: number;
  @IsNumber()
  @Expose()
  pairedCount!: number;
  @IsBoolean()
  @Expose()
  isPaired!: boolean;
  @IsBoolean()
  @Expose()
  isPairedWithCurrentReportItem!: boolean;
  @IsOptional()
  @IsString()
  @Expose()
  creationDate!: string | null;
  @IsNumber()
  @Expose()
  recordStampId!: number;
}

export class GDSBookingItemResponse extends GenericTableResponse<GDSBookingItem> {
  @Expose()
  @IsArray()
  @Type(() => GDSBookingItem)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<GDSBookingItem>;
}
